/* global axios */
import ApiClient from './ApiClient';

export const buildContactParams = (
  page,
  sortAttr,
  label,
  search,
  contactsView
) => {
  let params = `include_contact_inboxes=false&page=${page}&sort=${sortAttr}`;
  if (search) {
    params = `${params}&q=${search}`;
  }
  if (label) {
    params = `${params}&labels=${label}`;
  }
  if (contactsView === 'demo' || contactsView === 'all') {
    params = `${params}&contacts_view=${contactsView}`;
  }
  return params;
};

class ContactAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(page, sortAttr = 'name', label = '', contactsView = '') {
    let requestURL = `${this.url}?${buildContactParams(
      page,
      sortAttr,
      label,
      '',
      contactsView
    )}`;
    return axios.get(requestURL);
  }

  getConversations(contactId) {
    // Use lightweight payload for contact panel previews
    return axios.get(`${this.url}/${contactId}/conversations`, {
      params: { preview: true },
    });
  }

  getContactableInboxes(contactId) {
    return axios.get(`${this.url}/${contactId}/contactable_inboxes`);
  }

  getContactLabels(contactId) {
    return axios.get(`${this.url}/${contactId}/labels`);
  }

  updateContactLabels(contactId, labels) {
    return axios.post(`${this.url}/${contactId}/labels`, { labels });
  }

  search(
    search = '',
    page = 1,
    sortAttr = 'name',
    label = '',
    contactsView = ''
  ) {
    let requestURL = `${this.url}/search?${buildContactParams(
      page,
      sortAttr,
      label,
      search,
      contactsView
    )}`;
    return axios.get(requestURL);
  }

  // eslint-disable-next-line default-param-last
  filter(page = 1, sortAttr = 'name', queryPayload, contactsView = '') {
    let requestURL = `${this.url}/filter?${buildContactParams(page, sortAttr, '', '', contactsView)}`;
    return axios.post(requestURL, queryPayload);
  }

  destroyCustomAttributes(contactId, customAttributes) {
    return axios.post(`${this.url}/${contactId}/destroy_custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  destroyAvatar(contactId) {
    return axios.delete(`${this.url}/${contactId}/avatar`);
  }

  exportContacts(queryPayload) {
    return axios.post(`${this.url}/export`, queryPayload);
  }

  requestExportOtp() {
    return axios.post(`${this.url}/export_otp`);
  }

  upsertWhatsappAutomationPreferences(payload) {
    return axios.post(`${this.url}/whatsapp_automation_preferences`, payload);
  }
}

export default new ContactAPI();
